'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var reactHookForm = require('react-hook-form');
var zod$1 = require('@hookform/resolvers/zod');
var zod = require('zod');
var utils = require('@chakra-ui/utils');
require('../../components/Input/InputFormatted.js');
require('../../components/Input/InputPassword.js');
var Label = require('../../components/Label/Label.js');
require('../../components/Label/RequiredIndicator.js');
var FormError = require('../../components/FormError/FormError.js');
var Alert = require('../../components/Alert/Alert.js');
var AlertDescription = require('../../components/Alert/AlertDescription.js');
var AlertIcon = require('../../components/Alert/AlertIcon.js');
var AlertTitle = require('../../components/Alert/AlertTitle.js');
require('../../components/Alert/alertContext.js');
var Button = require('../../components/Button/Button.js');
require('../../components/Button/StatisticsButton.js');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
var CheckCircled = require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
require('../../components/Heading/Heading.js');
var HeadingH1 = require('../../components/Heading/HeadingH1.js');
require('../../components/Heading/HeadingH2.js');
require('../../components/Heading/HeadingH3.js');
require('../../components/Heading/HeadingH4.js');
require('../../components/Heading/HeadingH5.js');
require('../../components/Heading/HeadingDisplay.js');
require('../../components/Heading/HeadingSubline.js');
var Modal = require('../../components/Modal/Modal.js');
require('../../components/Modal/ModalBody.js');
require('../../components/Modal/ModalHeader.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var zod__namespace = /*#__PURE__*/_interopNamespace(zod);
var _excluded = ["onSubmit", "modal", "isInvalid", "isSuccess", "isLoading", "labelProps", "inputProps", "translations", "className", "useFormProps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Password reset form
 *
 * Renders our password reset form with validation.
 */
var ForgotPasswordForm = function ForgotPasswordForm(props) {
  var _t$email, _t$email$error, _t$email2, _t$email2$error, _t$error, _t$email3, _t$modal, _t$modal2;
  var onSubmit = props.onSubmit,
    modal = props.modal,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    _props$isSuccess = props.isSuccess,
    isSuccess = _props$isSuccess === void 0 ? false : _props$isSuccess,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    labelProps = props.labelProps,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {
      variant: 'floating'
    } : _props$inputProps,
    t = props.translations,
    className = props.className,
    useFormProps = props.useFormProps,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var SCHEMA = zod__namespace.object({
    email: zod__namespace.string().nonempty({
      message: t === null || t === void 0 ? void 0 : (_t$email = t.email) === null || _t$email === void 0 ? void 0 : (_t$email$error = _t$email.error) === null || _t$email$error === void 0 ? void 0 : _t$email$error.required
    }).email({
      message: t === null || t === void 0 ? void 0 : (_t$email2 = t.email) === null || _t$email2 === void 0 ? void 0 : (_t$email2$error = _t$email2.error) === null || _t$email2$error === void 0 ? void 0 : _t$email2$error.email
    })
  });
  var form = reactHookForm.useForm(_objectSpread(_objectSpread({}, useFormProps), {}, {
    resolver: zod$1.zodResolver(SCHEMA)
  }));
  var register = form.register,
    handleSubmit = form.handleSubmit,
    errors = form.formState.errors;
  var isOpen = modal.isOpen,
    onClose = modal.onClose;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(reactHookForm.FormProvider, form, isInvalid && /*#__PURE__*/React__default["default"].createElement(Alert.Alert, {
    mb: 5,
    status: "error"
  }, /*#__PURE__*/React__default["default"].createElement(AlertIcon.AlertIcon, null), /*#__PURE__*/React__default["default"].createElement(AlertDescription.AlertDescription, null, /*#__PURE__*/React__default["default"].createElement(AlertTitle.AlertTitle, null, t === null || t === void 0 ? void 0 : t.error.title), t === null || t === void 0 ? void 0 : (_t$error = t.error) === null || _t$error === void 0 ? void 0 : _t$error.text)), /*#__PURE__*/React__default["default"].createElement(react.chakra.form, _extends__default["default"]({
    className: utils.cx('chakra-forgot-password-form', className),
    noValidate: true,
    onSubmit: handleSubmit(onSubmit)
  }, rest), /*#__PURE__*/React__default["default"].createElement(react.FormControl, {
    id: "email",
    isInvalid: !!errors.email,
    isDisabled: isSuccess
  }, /*#__PURE__*/React__default["default"].createElement(Label.Label, labelProps, t === null || t === void 0 ? void 0 : (_t$email3 = t.email) === null || _t$email3 === void 0 ? void 0 : _t$email3.label), /*#__PURE__*/React__default["default"].createElement(react.Input, _extends__default["default"]({}, inputProps, {
    type: "email",
    autoComplete: "email"
  }, register('email'))), /*#__PURE__*/React__default["default"].createElement(FormError.FormError, null)), /*#__PURE__*/React__default["default"].createElement(Button.Button, {
    w: "full",
    isFloating: true,
    isLoading: isLoading,
    type: "submit",
    isDisabled: isSuccess
  }, t === null || t === void 0 ? void 0 : t.submit))), /*#__PURE__*/React__default["default"].createElement(Modal.Modal, {
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React__default["default"].createElement(react.ModalBody, null, /*#__PURE__*/React__default["default"].createElement(react.Flex, {
    direction: "column",
    align: "center",
    mb: 4
  }, /*#__PURE__*/React__default["default"].createElement(CheckCircled.CheckCircled, {
    color: "green.400",
    boxSize: 16
  })), /*#__PURE__*/React__default["default"].createElement(HeadingH1.HeadingH1, {
    size: "h4",
    textAlign: "center"
  }, t === null || t === void 0 ? void 0 : (_t$modal = t.modal) === null || _t$modal === void 0 ? void 0 : _t$modal.headline), t === null || t === void 0 ? void 0 : (_t$modal2 = t.modal) === null || _t$modal2 === void 0 ? void 0 : _t$modal2.explanation)));
};
ForgotPasswordForm.displayName = 'ForgotPasswordForm';
exports.ForgotPasswordForm = ForgotPasswordForm;